import React from 'react';
import { FaWhatsapp, FaPhoneAlt } from 'react-icons/fa';
import './FloatingActions.css';

const FloatingActions = () => {
  // Yahan aap apne alag-alag numbers daal sakte hain
  const whatsappNumber = "+919307604511"; // WhatsApp ke liye
  const callNumber = "+919923562524";     // Calling ke liye
  
  const whatsappMessage = "Hello! I'm interested in your travel packages.";

  return (
    <div className="floating-container">
      {/* WhatsApp Button */}
      <a 
        href={`https://wa.me/${whatsappNumber.replace('+', '')}?text=${encodeURIComponent(whatsappMessage)}`}
        className="floating-item whatsapp"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
      >
        <FaWhatsapp />
        <span className="tooltip">WhatsApp Us</span>
      </a>

      {/* Call Button */}
      <a 
        href={`tel:${callNumber}`} 
        className="floating-item call"
        aria-label="Call Us"
      >
        <FaPhoneAlt />
        <span className="tooltip">Call Now</span>
      </a>
    </div>
  );
};

export default FloatingActions;